import { postRequest } from '../../utils'
import { bookingServiceUrl } from '../../urls'

export const sendNotificationReq = ({ title, description, test }) => {
  return postRequest(`${bookingServiceUrl}/admin/notifications`, { title, description, test })
}
